<template>
  <company-report-mobile v-if="useMobileReport" canteen />
  <company-report-desktop v-else-if="useDesktopReport" canteen />
  <canteen-report-legacy v-else :show-new-view="useLegacyDesktop" @new-view="useNewView" />
</template>

<script>
import CanteenReportLegacy from "@/components/canteen-report/CanteenReportLegacy.vue";
import CompanyReportMobile from "@/components/company-report/mobile/CompanyReportMobile.vue";
import CompanyReportDesktop from "@/components/company-report/CompanyReportDesktop.vue";
import { LEGACY_UI_VALUE } from "@/components/report/desktop/reportQuery";

/**
 * Izveštaj kantina (/naplata/izvestaj-naplata): Radnici i Preuzeti obroci firme u kojoj je korisnik. Novi izgled je
 * isti kao izveštaji firme (ljuske company-report u varijanti "canteen"); ?ui=stari vraća staru stranicu (tabovi).
 */
export default {
  name: "CanteenReportPage",
  components: {
    CanteenReportLegacy,
    CompanyReportMobile,
    CompanyReportDesktop,
  },
  computed: {
    /** ?ui=stari vraća staru stranicu (tabovi) dok se novi izgled ne potvrdi. */
    useLegacyDesktop() {
      return !this.device.isMobile && this.$route.query.ui === LEGACY_UI_VALUE;
    },
    /** Telefon (širina do 600 px): početna sa izborom izveštaja i izveštaji u kartičnom prikazu. */
    useMobileReport() {
      return this.device.isMobile && this.$route.query.ui !== LEGACY_UI_VALUE;
    },
    /** Računar i tablet (širina iznad 600 px): gornja navigacija i zajednička traka filtera. */
    useDesktopReport() {
      return !this.device.isMobile && !this.useLegacyDesktop;
    },
  },
  methods: {
    /** Vraća novi izgled (briše ?ui=stari). */
    useNewView() {
      const query = { ...this.$route.query };
      delete query.ui;
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
